import { Button } from '@mui/material';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
// import Footer from '../../Components/shared/Footer/Footer';
import FooterConsulting from '../../Components/shared/Footer/FooterConsulting';
import NavbarConsulting from '../../Components/shared/Navbar/NavbarConsulting';
// import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import { DrawIcon7, DrawIcon8, DrawIcon9,DrawIcon10, DrawIcon11, DrawIcon12 } from '../../data/SVGConsulting';
import {DrawImageHomeExpert26 } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
import ImageHomeClient0 from './../../Assets/ConsultingHomePage/section_2_Consulting.png';

function ConsultingServices() {

    const navigate=useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    usePersistedLanguage();
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',width:'100%',background:'white',height:'fit-content'}}>
                <NavbarConsulting />

                <div style={{display:'flex',flexDirection:'column',gap:'65px',alignItems:'center',alignSelf:'stretch',paddingTop:device == 'desktop' ? '75px':'0px'}}>
                    <div
                        className='frame105HomePage'
                        id='expert'
                        style={{width:'90%'}}
                    >
                        <div className='frame106HomePage'>
                            <div className='frame107HomePage'>
                                <div className='frame108HomePage'>
                                    <h3 className='frame101HomePage'>
                                        {i18n.t('Des Solutions Innovantes pour Tous Vos Enjeux IT')}
                                    </h3>
                                    {device!='desktop' &&
                                                        <div className='frame112HomePage'>
                                                            <img
                                                                src={ImageHomeClient0}
                                                                // style={{borderRadius:'20px'}}
                                                            />
                                                        </div>
                                    }

                                    <h6 className='frame110HomePage'>
                                        {i18n.t('Chez High Tech Hires, nous mettons notre expertise au service de vos projets numériques. Nos consultants expérimentés couvrent un large éventail de domaines IT, allant de la gestion de l\'infrastructure à la transformation digitale, en passant par la cybersécurité et l\'optimisation des processus.')}
                                    </h6>
                                </div>
                                {/* <div className='frame111HomePage'>
                                                        <div className="frame0HomePage">
                                                            <Button
                                                                variant="contained"
                                                                style={{...buttonStylesBlue(false),...{height: '48px',width:device=='desktop'?'auto':'100%'}}}
                                                                onClick={()=>{
                                                                    navigate('/register');
                                                                }}

                                                            > {i18n.t('S\'inscrire')}
                                                            </Button></div>

                                                    </div> */}
                            </div>
                            {device=='desktop' &&
                                                <div className='frame112HomePage'>
                                                    <img
                                                        src={ImageHomeClient0}
                                                        // style={{borderRadius:'20px'}}
                                                    />
                                                </div>
                            }

                        </div>
                    </div>

                    <div className='frame5HomePage'>
                        {/* <div className='frame6HomePage'> */}
                        <h3
                            className='frame101HomePage'
                            style={{alignSelf:'center'}}
                        >
                            <Trans>
                                {i18n.t('Nos métiers')}
                            </Trans>
                        </h3>
                        {/* </div> */}
                        <div
                            style={{
                                display:'grid',
                                gridTemplateColumns:device=='desktop'?'repeat(3,1fr)':'repeat(1,1fr)',
                                gap:'24px',
                                width: '100%',
                                alignItems: 'center',
                                //isolation: 'isolate',
                                maxWidth: '1268px',
                                minWidth: device=='desktop'?'600px':'200px',
                            }}
                        >
                            <div className='homeExpertf47'>
                                <div style={{textAlign:'center',width:'100%',height:'auto'}}>
                                    <DrawIcon7 />
                                </div>

                                <div
                                    className='homeExpertf48'
                                    style={{textAlign:'center',alignItems:'center'}}
                                >
                                    <h5
                                        className='homeExpertf16'
                                        style={{margin:0}}
                                    >
                                        {i18n.t('Consulting en Transformation Digitale')}
                                    </h5>
                                    <p className='homeExpertf49'>
                                        {i18n.t('Des professionnels chevronnés dans divers secteurs tels que MM, SD, FI, CO, PM, BW, etc., ayant une expertise complète dans l\'ensemble des solutions proposées par SAP.')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf47'>
                                <div style={{textAlign:'center',width:'100%',height:'auto'}}>
                                    <DrawIcon8 />
                                </div>
                                <div
                                    className='homeExpertf48'
                                    style={{textAlign:'center',alignItems:'center'}}
                                >
                                    <h5
                                        className='homeExpertf16'
                                        style={{margin:0}}
                                    >
                                        {i18n.t('Développement de Logiciels et Applications')}
                                    </h5>
                                    <p className='homeExpertf49'>
                                        {i18n.t('Nous concevons des applications web et mobiles sur mesure, tout en automatisant vos processus pour augmenter l’efficacité et la performance de vos équipes.')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf47'>
                                <div style={{textAlign:'center',width:'100%',height:'auto'}}>
                                    <DrawIcon9 />
                                </div>
                                <div
                                    className='homeExpertf48'
                                    style={{textAlign:'center',alignItems:'center'}}
                                >

                                    <h5
                                        className='homeExpertf16'
                                        style={{margin:0}}
                                    >
                                        {i18n.t('ERP/CRM/SCM')}
                                    </h5>
                                    <p className='homeExpertf49'>
                                        {i18n.t('Nous intégrons et personnalisons des solutions ERP et CRM (SAP, Odoo, Microsoft Dynamics) pour améliorer la gestion de vos ressources et relations clients.')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf47'>
                                <div style={{textAlign:'center',width:'100%',height:'auto'}}>
                                    <DrawIcon10 />
                                </div>
                                <div
                                    className='homeExpertf48'
                                    style={{textAlign:'center',alignItems:'center'}}
                                >
                                    <h5
                                        className='homeExpertf16'
                                        style={{margin:0}}
                                    >
                                        {i18n.t('Cloud & Infrastructure IT')}
                                    </h5>
                                    <p className='homeExpertf49'>
                                        {i18n.t('Nous gérons la migration vers le cloud (AWS, Azure, GCP) et optimisons vos infrastructures IT pour maximiser la flexibilité, la scalabilité et la sécurité.')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf47'>
                                <div style={{textAlign:'center',width:'100%',height:'auto'}}>
                                    <DrawIcon11 />
                                </div>
                                <div
                                    className='homeExpertf48'
                                    style={{textAlign:'center',alignItems:'center'}}
                                >
                                    <h5
                                        className='homeExpertf16'
                                        style={{margin:0}}
                                    >
                                        {i18n.t('Cybersécurité & Compliance')}
                                    </h5>
                                    <p className='homeExpertf49'>
                                        {i18n.t('Nous sécurisons vos systèmes et vos données tout en vous assurant que vous respectez les normes de conformité telles que le RGPD et l’ISO 27001.')}
                                    </p>

                                </div>
                            </div>

                            <div className='homeExpertf47'>
                                <div style={{textAlign:'center',width:'100%',height:'auto'}}>
                                    <DrawIcon12 />
                                </div>
                                <div
                                    className='homeExpertf48'
                                    style={{textAlign:'center',alignItems:'center'}}
                                >

                                    <h5
                                        className='homeExpertf16'
                                        style={{margin:0}}
                                    >
                                        {i18n.t('Support Technique  ')}
                                    </h5>
                                    <p className='homeExpertf49'>
                                        {i18n.t('Nous offrons un support technique réactif et une maintenance proactive pour garantir la continuité de vos opérations et la performance optimale de vos systèmes IT.')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='homeExpertf44'>
                        <div className='homeExpertf45'>
                            <h3 className='frame101HomePage'>
                                {i18n.t('Prêt à donner vie à votre projet avec notre expertise ? ')}
                            </h3>
                            {device!='desktop' &&
                            <DrawImageHomeExpert26 />
                            }
                            <Button
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                                onClick={()=>{
                                    navigate('/ContactUs');
                                }}
                            >
                                {i18n.t('Nous contacter')}
                            </Button>
                        </div>
                        {device=='desktop' &&
                        <DrawImageHomeExpert26 />
                        }
                    </div>

                </div>
                <FooterConsulting
                    styleProps={{background: '#005E23',
                    }}
                />
            </div>
        </>
    );
}

export default ConsultingServices;